/**
 * Logger utilitaire pour le frontend Raiso.
 * En production, seuls les logs WARN et ERROR sont émis pour limiter le bruit
 * tout en conservant la visibilité sur les incidents et comportements anormaux.
 *
 * TODO: Intégrer log shipping vers le backend Raiso pour persistance et analytics
 * du comportement utilisateur en production. Pattern suggéré :
 *   - Intercepter les appels Logger.error() en production
 *   - Envoyer via POST /api/v1/frontend-logs avec { level, message, context, timestamp }
 *   - Stocker dans l'index ES `logs-raiso-frontend-*` pour centralisation avec les logs backend
 */
export class Logger {
  public static log(...args: unknown[]): void {
    if (import.meta.env.PROD) return;
    console.log(...args);
  }

  public static info(...args: unknown[]): void {
    if (import.meta.env.PROD) return;
    console.info(...args);
  }

  public static warn(...args: unknown[]): void {
    console.warn(...args);
  }

  public static error(...args: unknown[]): void {
    console.error(...args);
  }

  public static debug(...args: unknown[]): void {
    if (import.meta.env.PROD) return;
    console.debug(...args);
  }
}
